import { useEffect, useState } from "react";
import { fetchGuilds } from "../requests/discord/fetchGuilds";
import { fetchUser } from "../requests/discord/fetchUser";
import { isLocalStorageAvailable } from "../isLocalStorageAvailable";
import { useRouter } from "next/router";
import axios from "axios";

export const useBotAuth = (botName) => {
  const [authorized, setAuthorized] = useState(false);
  const [guilds, setGuilds] = useState([]);
  const [user, setUser] = useState([]);
  const router = useRouter();

  useEffect(() => {
    const code = router?.query?.code;

    if (code) {
      axios
        .post("/api/discord/auth", { code, botName })
        .then((response) => {
          window.__ds__auth = response.data;
          if (isLocalStorageAvailable()) {
            localStorage.setItem("__ds__auth", JSON.stringify(response.data));
          } else {
            window.__ds__auth = response.data;
          }

          setAuthorized(true);

          return Promise.all([fetchGuilds(), fetchUser()]);
        })
        .then(([fetchedGuilds, fetchedUser]) => {
          setGuilds(fetchedGuilds);
          setUser(fetchedUser);
        })
        .catch((e) => console.log(e))
        .finally(() => {
          router.replace(router.pathname);
        });
    }

    if (window.__ds__auth && !authorized) {
      fetchGuilds().then(setGuilds);
      fetchUser().then(setUser);
    }
  }, [router]);

  useEffect(() => {
    const isAuth = !!(isLocalStorageAvailable()
      ? localStorage.getItem("__ds__auth")
      : window.__ds__auth);

    setAuthorized(isAuth);

    if (isAuth) {
      // fetch if authorized
      fetchGuilds().then(setGuilds);
      fetchUser().then(setUser);
    }
  }, []);
  return {
    authorized,
    guilds,
    user,
  };
};
